

export const Action_GetDMAttributes = "Action_GetDMAttributes";
export const Action_GetDMAttributesSuccess = "Action_GetDMAttributesSuccess";
